import { render, staticRenderFns } from "./ManageDataSystem.vue?vue&type=template&id=0fba30a0&scoped=true"
import script from "./ManageDataSystem.vue?vue&type=script&lang=js"
export * from "./ManageDataSystem.vue?vue&type=script&lang=js"
import style0 from "./ManageDataSystem.vue?vue&type=style&index=0&id=0fba30a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fba30a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fba30a0')) {
      api.createRecord('0fba30a0', component.options)
    } else {
      api.reload('0fba30a0', component.options)
    }
    module.hot.accept("./ManageDataSystem.vue?vue&type=template&id=0fba30a0&scoped=true", function () {
      api.rerender('0fba30a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/other/ManageDataSystem.vue"
export default component.exports